import React from 'react';
import {Link} from "react-router-dom";
import Header from '../modules/header'
import $ from "jquery";
import Footerslider from '../components/FooterSlider/footerslider';
import axios from 'axios';
import parse from 'html-react-parser';

class Terms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        content: '',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    
    axios.get(`${process.env.REACT_APP_API_URL}/content/terms.json`)
    .then((response) => {;
        this.setState({ content: response.data.terms.fields.content});
        window.scrollTo(0, 0)
    })
    .catch();

    $(".arrow-down a").on('click', function(event) {
        if (this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 800, function() {
                window.location.hash = hash;
            });
        }
    });
    // backto top jquery
    if ($('#back-to-top').length) {
        var scrollTrigger = 100, // px
            backToTop = function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > scrollTrigger) {
                    $('#back-to-top').addClass('show');
                } else {
                    $('#back-to-top').removeClass('show');
                }
            };
        backToTop();
        $(window).on('scroll', function () {
            backToTop();
        });
        $('#back-to-top').on('click', function (e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
  }
  render() {
  
  return (
    <div className="open_menudiv">
      <Header></Header>
      <div className="hero-slider section search-hero" id="search_page">
        <div className="hero-item" id="generic-header">
          <div className="slider-dark-overlay" />
          <div className="container">
            <div className="row">
              <div className="hero-content-wrap col">
                <div className="hero-content searchpage-content">
                  <div className="slide-txt">
                    <p id="serrch_fline" className="first-line text-center"></p>
                    <h1 className="second-line text-center">Terms and Conditions</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="calendar1">
                <div className="gems-content">
                  <p>{parse(this.state.content)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
}
};

export default Terms;
